import React from 'react'
import * as Styled from './Tabs.styles'
import TabControl from './TabControl/TabControl'

function getPreviousTab(active, tabs) {
  for (let i = active - 1; i >= 0; i -= 1) {
    if (!tabs[i].props.disabled) {
      return i
    }
  }

  return active
}

function getNextTab(active, tabs) {
  for (let i = active + 1; i < tabs.length; i += 1) {
    if (!tabs[i].props.disabled) {
      return i
    }
  }

  return active
}

const Tabs = ({ children }) => {
  const [activeTab, setActiveTab] = React.useState(0)

  const controlRefs = React.useRef({})
  const tabs = React.Children.toArray(children)

  const handleKeyDown = (event) => {
    if (event.nativeEvent.code === 'ArrowRight') {
      event.preventDefault()
      const nextTab = getNextTab(activeTab, tabs)
      setActiveTab(nextTab)
      controlRefs.current[nextTab].focus()
    }

    if (event.nativeEvent.code === 'ArrowLeft') {
      event.preventDefault()
      const previousTab = getPreviousTab(activeTab, tabs)
      setActiveTab(previousTab)
      controlRefs.current[previousTab].focus()
    }
  }

  const panes = tabs.map((tab, index) =>
    React.cloneElement(tab, {
      key: index,
      active: activeTab === index,
      onKeyDown: handleKeyDown,
      elementRef: (node) => {
        controlRefs.current[index] = node
      },
      onClick: () => activeTab !== index && setActiveTab(index),
    })
  )

  const content = tabs[activeTab].props.children

  return (
    <Styled.Tabs>
      <div role='tablist' className='panes'>
        {panes}
      </div>
      {content && (
        <div role='tabpanel' className='tab-content'>
          {content}
        </div>
      )}
    </Styled.Tabs>
  )
}

Tabs.Tab = TabControl

export default Tabs
